/*اداره*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={102.073}
      height={102.073}
      viewBox="0 0 102.073 102.073"
      {...props}
    >
      <path
        d="M58.989 58.622v2.5L48.58 63.405a9.768 9.768 0 00-7.675 9.541v19.162h47.049V72.947a9.768 9.768 0 00-7.682-9.543L69.81 61.117v-2.514"
        fill="#5ddef5"
      />
      <path d="M69.81 61.118l-5.411 14.47-5.411-14.47z" fill="#fff" />
      <path
        d="M64.43 29.292a11.461 11.461 0 00-11.461 11.461v2.759h5.6a12.592 12.592 0 009.651-4.5l7.667 4.5v-2.759A11.46 11.46 0 0064.43 29.292z"
        fill="#afabb0"
      />
      <path
        d="M65.755 41.259a12.589 12.589 0 01-7.182 2.252h-5.6v4.868A11.461 11.461 0 0064.434 59.84a11.461 11.461 0 0011.461-11.461v-4.868l-3.833-2.252-3.833-2.252z"
        fill="#fed2a4"
      />
      <path fill="#ffbe52" d="M1.994 92.105h98.086v7.974H1.994z" />
      <circle
        cx={16.456}
        cy={16.456}
        r={16.456}
        transform="translate(1.994 1.994)"
        fill="#93e7f8"
      />
      <path fill="#c7c4c8" d="M1.994 45.255h43.062v31.898H1.994z" />
      <path
        d="M27.511 84.928h-7.974V65.191a3.987 3.987 0 013.987-3.987 3.987 3.987 0 013.987 3.987zM33.892 92.105H13.158v-2.99a4.187 4.187 0 014.187-4.187h12.36a4.187 4.187 0 014.187 4.187z"
        fill="#5ddef5"
      />
      <path fill="#fff" d="M74.561 84.131h25.518v7.974H74.561z" />
      <path fill="#e8e7e9" d="M74.561 76.156h25.518v7.974H74.561z" />
      <path fill="#fff" d="M74.561 68.182h25.518v7.974H74.561z" />
      <g>
        <path d="M18.45 36.9A18.45 18.45 0 100 18.45 18.471 18.471 0 0018.45 36.9zm0-32.913A14.463 14.463 0 113.987 18.45 14.479 14.479 0 0118.45 3.987z" />
        <path d="M20.036 22.832a1.994 1.994 0 002.815-2.824l-2.394-2.386v-8.85a1.994 1.994 0 10-3.987 0v9.678a2 2 0 00.586 1.412zM100.08 66.188H87.81a11.773 11.773 0 00-7.111-4.73l-8.765-1.916a13.452 13.452 0 005.95-11.162v-7.627a13.454 13.454 0 10-26.908 0v7.627a13.452 13.452 0 005.937 11.153l-8.759 1.922c-.374.082-.742.183-1.1.3v-16.5a1.994 1.994 0 00-1.994-1.994H31.5a1.994 1.994 0 000 3.987h11.562v27.911H29.506v-9.968a5.981 5.981 0 00-11.962 0v9.968H3.987V47.248H15.55a1.994 1.994 0 000-3.987H1.994A1.994 1.994 0 000 45.255v31.9a1.994 1.994 0 001.994 1.994h15.55v3.788h-.2a6.187 6.187 0 00-6.18 6.18v1h-9.17A1.994 1.994 0 000 92.105v7.974a1.994 1.994 0 001.994 1.99h98.086a1.994 1.994 0 001.994-1.994v-31.9a1.994 1.994 0 00-1.994-1.987zM87.954 90.111h-11.4v-3.987h21.532v3.987zm10.132-7.974H76.555v-3.988h21.531zm0-7.974H76.555v-3.987h21.531zm-43.124-33.41a9.467 9.467 0 0118.905-.741l-4.634-2.723a1.993 1.993 0 00-2.538.438 10.572 10.572 0 01-8.123 3.791h-3.61v-.766zm0 4.753h3.61a14.545 14.545 0 0010.009-3.975l5.315 3.123v3.727a9.467 9.467 0 01-18.934 0v-2.874zm12.59 15.959l-3.152 8.43-3.159-8.447a13.385 13.385 0 006.312.015zm-22.5 17.683a1.994 1.994 0 001.994-1.994v-11.09a7.752 7.752 0 011.958-.715l8.72-1.913 4.805 12.85a1.993 1.993 0 003.734 0l4.805-12.851 8.774 1.918a7.762 7.762 0 012.173.835h-7.454a1.994 1.994 0 00-1.994 1.994v21.93H42.9V79.146h2.157zm-6.145 0v10.965h-3.022v-1a6.187 6.187 0 00-6.18-6.18h-.2v-3.788zm-17.38-13.955a1.994 1.994 0 013.987 0v17.743h-3.983zm-6.38 23.923a2.2 2.2 0 012.193-2.193H29.7a2.2 2.2 0 012.193 2.193v1H15.151zm82.934 8.971H3.987V94.1h94.1z" />
        <path d="M22.115 43.846a1.992 1.992 0 101.409-.584 2.009 2.009 0 00-1.409.584z" />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
